import { jsx } from 'react/jsx-runtime';
import { SVG } from '../utils/style.svg.js';
import { getDefaultHeight } from '../utils/get-default-height.js';

const NewlineIcon = ({
  color,
  ...svgProps
}) => {
  return /*#__PURE__*/jsx(SVG, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 23",
    height: getDefaultHeight(svgProps, 23),
    ...svgProps,
    stroke: svgProps.stroke ?? "none",
    fill: color ?? svgProps.fill ?? "currentColor",
    children: /*#__PURE__*/jsx("path", {
      d: "M17 15h1v1h-1v-1Zm-16.707.707a1 1 0 0 1 0-1.414l6.364-6.364A1 1 0 0 1 8.07 9.343L2.414 15l5.657 5.657a1 1 0 1 1-1.414 1.414L.293 15.707ZM17 1V0h1v1h-1Zm0 15H1v-2h16v2Zm-1-1V1h2v14h-2Zm1-13h-6.222V0H17v2Z"
    })
  });
};

export { NewlineIcon };
//# sourceMappingURL=newline.js.map
